import { cloneDeep } from "lodash";
const initialState = {
  fetching: false,
  vendor_items: [],
  total_records: 0,
  filters: [],
  sortOptions: {},
  pagination: {
    pageNumber: 1,
    pageSize: 25
  },
  vendors: [],
  items_entries: {}
};

const vendorProcessedCatalogs = (state = cloneDeep(initialState), action) => {
  switch (action.type) {
    case 'GET_ITEMS_FOR_VENDOR_REQUEST': {
      return {
        ...state,
        fetching: true
      };
    }
    case 'GET_ITEMS_FOR_VENDOR_SUCCESS': {
      const { processed, file_upload, total_records } = action.payload;
      const { errored_entries, processed_entries, processing_entries } = file_upload;
      return {
        ...state,
        fetching: false,
        total_records,
        vendor_items: processed,
        items_entries: { errored_entries, processed_entries, processing_entries }
      };
    }
    case 'GET_ITEMS_FOR_VENDOR_FAILED': {
      return {
        ...state,
        fetching: false
      };
    }
    case 'GET_VENDOR_NAMES_FOR_VENDOR_PROCESSED_CATALOGS_REQUEST': {
      return {
        ...state,
        fetching: true
      };
    }
    case 'GET_VENDOR_NAMES_FOR_VENDOR_PROCESSED_CATALOGS_SUCCESS': {
      return {
        ...state,
        fetching: false,
        vendors: action.payload ? [...action.payload] : []
      };
    }
    case 'GET_VENDOR_NAMES_FOR_VENDOR_PROCESSED_CATALOGS_FAILED': {
      return {
        ...state,
        fetching: false
      };
    }
    case 'SET_PAGINATION_FOR_VENDOR_PROCESSED_CATALOGS_CATALOGS': {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload
        }
      }
    }
    case 'SET_FILTERS_FOR_VENDOR_PROCESSED_CATALOGS_CATALOGS': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'SET_SORT_OPTIONS_FOR_VENDOR_PROCESSED_CATALOGS_CATALOGS': {
      return {
        ...state,
        ...action.payload
      };
    }
    default:
      return state;
  }
};

export default vendorProcessedCatalogs;
